import { render, staticRenderFns } from "./admire.vue?vue&type=template&id=015af5d6&scoped=true&"
import script from "./admire.vue?vue&type=script&lang=js&"
export * from "./admire.vue?vue&type=script&lang=js&"
import style0 from "./admire.vue?vue&type=style&index=0&id=015af5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015af5d6",
  null
  
)

export default component.exports